/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ target: NonNullable<unknown> }} Consumption_Target_SeriesInputs */



/**
* | output |
* | --- |
* | "Target {target}" |
*
* @param {Consumption_Target_SeriesInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_target_series = /** @type {((inputs: Consumption_Target_SeriesInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_Target_SeriesInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Target ${i?.target}`)
	return /** @type {LocalizedString} */ (`Objectif ${i?.target}`)
});